import { render, staticRenderFns } from "./rewardDiceFreeSpinEdit.vue?vue&type=template&id=1de86b40&scoped=true&"
import script from "./rewardDiceFreeSpinEdit.vue?vue&type=script&lang=js&"
export * from "./rewardDiceFreeSpinEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de86b40",
  null
  
)

export default component.exports